import React from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

export const AiMarkdown = ({ text, testId }) => (
  <div data-testid={testId} className="ai-markdown text-sm text-gray-800 leading-relaxed space-y-2 normal-case overflow-x-auto">
    <ReactMarkdown remarkPlugins={[remarkGfm]}>{text}</ReactMarkdown>
  </div>
);
